import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { NoContractArea } from "./Styles";

export default function NoContrato({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="Contrato"
            value={!value ? document.documents.contract.code : value}
          />
        </div>
      ) : (
        <NoContractArea>
          <Informative
            readonly={true}
            label="Contrato"
            value={!value ? document.documents.contract.code : value}
          />
        </NoContractArea>
      )}
    </>
  );
}
